import React, { ReactNode, CSSProperties } from 'react';

interface ViewProps {
  isSafe?: boolean;
  style?: any;
  children?: ReactNode;
}

export const View = ({ isSafe, style, children }: ViewProps) => {
  // Convert React Native style object to CSS inline style
  const cssStyle: CSSProperties = style || {};
  
  return <div style={cssStyle}>{children}</div>;
};
